module.exports = __webpack_public_path__ + "static/nutrition-hcp-logo-e3dc0c0ad27ddf95d7ef8c42ffc04020.png";